import React, { Component } from "react";
import { AtlasKitThemeProvider } from "@atlaskit/theme";
import axios from "axios";
import Config from "../config";
import { ModalTransition } from "@atlaskit/modal-dialog";
import AddParticipants from "./add-participants";
import Upload from "./upload";
import CreatedRoom from "./created-room";
import Embbeded from "./embbeded";
import ClaimRoomComponent from "./claimRoom";
import DeviceList from "../../webjam/components/webjam";
import WebjamMixer from "../../webjam/components/mixer";
import {
  getRoomDetail,
  makeRoomPayment,
} from "../welcome-dashboard/Request.d";
import Toast from "react-simple-toasts";
import { messages, stripeMessage } from "../welcome-dashboard/messages";
import {
  setWaitingScreen, setWaitingScreenStatus
} from "../redux/tool-webjam/actions";
import { connect as reactReduxConnect } from "../../base/redux";
import { FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2, FEATURE_CUSTOM_REDUX_V3 } from "../constant";
import {
  calculateTimeDiff,
  connectAccountFlag,
  dispatch,
  getBaseConfig,
  isSocialMobileApp,
  _startConference,
  getStore
} from "../Utils";
import {
  getLocalParticipant,
  isLocalParticipantModerator,
} from "../../base/participants";
import { toggleLobbyMode } from "../../lobby/actions";
import { apiVersion, getLJsonStorage, startsWithNumber } from "../welcome-dashboard/Utils";
const { socket_endpoint } = Config;
import { v4 as uuidv4 } from "uuid";
import config from "../config";
import toast from "react-simple-toasts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import PaymentAccountModal from "./PaymentAccountModal";
import { setStripeRequesting } from "../redux/tool-webjam-v2/actions";
import { Translate } from "../../webjam/language";
import { getActiveSession } from "../../recording";
import { JitsiRecordingConstants } from "../../base/lib-jitsi-meet";
import { CURRENT_ROOM_NAME, Constant } from "../../webjam/constant";
import { canUserJoinMeeting } from "../custom/components/HelperComponent";
import { setUserMakeRoomPayment } from "../redux/tool-webjam-v3/actions";
import Dialog from "../../base/ui/components/web/Dialog";
import { checkSubscription, ct, dynamicMessageLocale } from "../constant-Utils";
import { handleSubscription } from "../custom/components/CommonComponents";

var url = window.location.href.replace(/\/$/, "");
var lastSeg = CURRENT_ROOM_NAME;
// if (lastSeg) {
//   lastSeg = lastSeg.substring(1);
// }
var now = new Date();
var day = ("0" + now.getDate()).slice(-2);
var month = ("0" + (now.getMonth() + 1)).slice(-2);
var today = now.getFullYear() + "-" + month + "-" + day;

class Explore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,

      createRoom: "",
      exploreCategory: "",
      roomType: "both",
      rooms: [],
      selectedRoom: "",
      isLoading: false,
      popWindow: "",
      popWindowUid: "",
      connectAccount: false,
      connectPop: false,
      connectVerified: "",
      connectApprovedFlash: false,
      claim: {
        groupName: lastSeg,
        admin: true,
        email: "",
        userName: "",
        alreadyAccount: false,
        password: "",
        private: false,
        paid: false,
        publish: false,
        showCat: false,
        showPaid: false,
        category: "",
        room_amount: "",
        endDate: "",
        accountDetails: {},
      },
      payment: {
        card_number: "",
        expiry: "",
        cvc: "",
        password: "",
      },
      paymentDetail: {
        url: "",
        message: "",
      },
      isMakingPayment: false,
      errors: {
        category: "",
        payment: "",
        roomDate: "",
      },
      stopRoomPaymentInterval: false,
    };

    this.paidRef = React.createRef();
    this.eDateRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    // if (prevProps.user !== this.props.user) {
    if (prevProps?.user?.user?.email !== this.props?.user?.user?.email) {
      const { user } = this.props.user;

      this.setState({
        claim: {
          ...this.state.claim,
          userName: user.username,
          email: user.email,
          alreadyAccount: !!user.account_Stripe_Id,
        },
      });
    }

    let { explorePop } = this.props;

    if (prevProps.explorePop != explorePop) {
      if (explorePop == "claim-room") {
        this.setState({
          claim: {
            ...this.state.claim,
            paid: false,
            showPaid: false,
            room_amount: "",
            endDate: "",
          },
          errors: {
            roomDate: "",
            payment: "",
            category: "",
          },
        });

        // let hasConnectAccount = getLJsonStorage("auth", "stripe_account_id");
        // if (hasConnectAccount) {
        //   let connectVerified = getLJsonStorage("auth", "connectVerified");

        //   this.setState({
        //     connectAccount: true,
        //     connectVerified: connectVerified
        //   })
        // } else {
        //   this.setState({
        //     connectAccount: false,
        //     connectVerified: ""
        //   })
        // }
      }

      if (prevProps.explorePop == "claim-room" && explorePop == "") {
        this.setState({
          connectApprovedFlash: false,
        });
      }
    }
    const { userLoginData, isStripeConnect, connectVerified } = this.props;

    if (userLoginData.room) {
      if (userLoginData.isPaid != prevProps.userLoginData.isPaid) {
        if (userLoginData.isPaid) {
          if (this.state.isMakingPayment) {
            this.setState({
              paymentDetail: {
                url: "",
                message: "",
              },
              isLoading: false,
            });
          }
        }
      }
    }

    if (prevProps.isStripeConnect != isStripeConnect) {
      if (isStripeConnect) {
        this.setState({
          connectAccount: true,
        });
      }
    }

    if (prevProps.connectVerified != connectVerified) {
      if (connectVerified) {
        if (connectVerified == connectAccountFlag.APPROVED) {
          let _this = this;

          setTimeout(function () {
            if (_this.paidRef != undefined) {
              if (_this.paidRef.current != undefined) {
                _this.paidRef.current.click();
              }
            }

            let stt = {
              claim: {
                ..._this.state.claim,
                showPaid: true,
                paid: true,
              },
              connectAccount: true,
              connectVerified: connectAccountFlag.APPROVED,
              connectApprovedFlash: true,
            };
            setTimeout(function () {
              _this.setState(stt);
            }, 1000);

            setTimeout(function () {
              _this.setState({
                connectApprovedFlash: false,
              });
            }, stripeMessage.successFlushTime);
          }, 100);
        }
        this.setState({
          connectVerified: connectVerified,
        });
      }
    }

    let { errors } = this.state;

    if (prevState?.claim?.endDate != this.state?.claim?.endDate) {
      if (errors?.roomDate) {
        this.setState({
          errors: {
            ...errors,
            roomDate: "",
          },
        });
      }

      if (this.eDateRef) {
        if (this.eDateRef.current) {
          let _this = this;
          setTimeout(function () {
            _this.eDateRef.current.setOpen(false);
          }, 100);
        }
      }
    }
    if (prevState?.claim) {
      if (prevState.claim?.room_amount != this.state.claim?.room_amount) {
        if (errors?.payment) {
          this.setState({
            errors: {
              ...errors,
              payment: "",
            },
          });
        }
      }

      if (prevState.claim?.category != this.state.claim?.category) {
        if (errors?.category) {
          this.setState({
            errors: {
              ...errors,
              category: "",
            },
          });
        }
      }
    }

    const { deviceContainerStatus } = this.props;
    if (
      prevProps.deviceContainerStatus != deviceContainerStatus &&
      deviceContainerStatus == "closeWebjamMixer"
    ) {
      if (explorePop == "webjam-mixer") {
        this.props.changePopupState("a");
      }
    }
  }

  changeField = ({ target: { value, name } }) => {
    const { exploreCategory, roomType } = this.state;

    if (name === "exploreCategory" && value !== "") {
      axios
        .get(
          `${socket_endpoint + (getBaseConfig("apiVersion") || apiVersion)
          }/get_explore_rooms/true/${value}/${roomType}`
        )
        .then((response) => {
          if (response.data && response.data.data) {
            if (response.data.data.length === 0) {
              Toast(
                ct("messages.unavailableRoom", "messages"),
                Constant.App.ToastTime.LongCloseTime
              );
            }
            this.setState({
              selectedRoom: "",
              rooms: response.data.data,
            });
          }
        })
        .catch((error) => {
          console.log("get_explore_rooms 1 error =>", error);
        });
    } else if (name === "exploreCategory" && value === "") {
      this.setState({
        rooms: [],
      });
    } else if (name === "roomType" && exploreCategory !== "") {
      axios
        .get(
          `${socket_endpoint + (getBaseConfig("apiVersion") || apiVersion)
          }/get_explore_rooms/true/${exploreCategory}/${value}`
        )
        .then(async (response) => {
          if (response.data && response.data.data) {
            // if (response.data.data.length === 0) {
            //   Toast(messages.unavailableRoom);
            // }
            if (response.data.status) {
              this.setState({
                selectedRoom: "",
                rooms: response.data.data,
              });
            }
          } else {
            this.setState({
              selectedRoom: "",
              rooms: [],
            });
            let msg = await dynamicMessageLocale(response.data.message);
            Toast(msg, Constant.App.ToastTime.LongCloseTime);
          }
        })
        .catch((error) => {
          console.log("get_explore_rooms 2 error =>", error);
        });
    }

    this.setState({
      [name]: value,
    });
  };

  cancelRoomClick = () => {
    this.props.changePopupState("b");
    this.setState({
      createRoom: "",
    });
  };

  onSubmit = async () => {
    const { createRoom } = this.state;
    if (createRoom && createRoom.trim()) {
      const haveSubscription = this.props.isSubscriptionActive;

      if (!haveSubscription) {
        handleSubscription();
        return false;
      }

      const newRoomName = createRoom.replace(/[^A-Z0-9]+/gi, "");
      if (newRoomName.length < 3) {
        Toast(
          ct("messages.inviteNameLength", "messages"),
          Constant.App.ToastTime.LongCloseTime
        );
        return false;
      }
      if (newRoomName.length > 25) {
        Toast(
          ct("messages.invalidRoomLength", "messages"),
          Constant.App.ToastTime.LongCloseTime
        );
        return false;
      }
      if (startsWithNumber(newRoomName)) {
        Toast(
          ct("messages.invalidRoomName", "messages"),
          Constant.App.ToastTime.LongCloseTime
        );
        return false;
      }
      sessionStorage.setItem("createRoom", true);

      let socialAllowed = getBaseConfig("socialAllowed");
      if (socialAllowed == true) {
        if (isSocialMobileApp()) {
          window.location.href = getBaseConfig("appReferrerUrl") + "/" + newRoomName;
        } else {
          window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/" + newRoomName;
        }
      } else {
        window.location.href = `/${newRoomName}`;
      }
    } else {
      Toast(
        ct("messages.roomRequired", "messages"),
        Constant.App.ToastTime.LongCloseTime
      );
    }
  }

  createRoomModel = () => {
    const { createRoom } = this.state;
    const { changePopupState } = this.props;

    return (
      <Dialog
        disableAutoHideOnSubmit={true}
        disableBackdropClose={true}
        hideCloseButton={true}
        onCancel={() => this.cancelRoomClick()}
        onSubmit={() => this.onSubmit()}
        cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall") }}
        ok={{ translationKey: ct("rta-trmc.dialogs.createRoom") }}
        titleKey={ct("rta-trmc.dialogs.createRoom")}
        rtaClassName="create-room-wrapper"
        testId={"create-room-modal"}
      >
        <input
          autoComplete="off"
          name="createRoom"
          type="text"
          value={createRoom}
          // className="input-control"
          onChange={this.changeField}
          // className="form-control"
          className="input-control form-control theme-input-focus"
          placeholder={ct("rta-trmc.dashboard.myRecording.roomName")}
          autoFocus
        />
      </Dialog>
    );
  };

  getRooms = () => {
    const { rooms } = this.state;

    let roomsOptions = [];
    roomsOptions.push(
      <option key={-1} value="">
        {ct("rta-trmc.rtaInviteModal.selectRoom")}
      </option>
    );
    for (let i = 0; i <= rooms.length - 1; i++) {
      const { groupName } = rooms[i];

      roomsOptions.push(
        <option key={i} alt={groupName} value={groupName}>
          {groupName}
        </option>
      );
    }

    return roomsOptions;
  };

  cancelClick = () => {
    this.props.changePopupState("c");
    this.setState({
      exploreCategory: "",
      roomType: "both",
      rooms: [],
      selectedRoom: "",
    });
  };

  handleOnSubmit = () => {
    const { selectedRoom } = this.state;
    if (selectedRoom && selectedRoom.trim()) {
      if (isSocialMobileApp()) {
        window.parent.location.href = getBaseConfig("appReferrerUrl") + "/" + selectedRoom;
      } else {
        // social url change code
        let socialAllowed = getBaseConfig("socialAllowed");
        if (socialAllowed == true) {
          window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/" + selectedRoom;
        } else {
          window.location.href = `/${selectedRoom}`;
        }
      }
    } else {
      Toast(
        ct("messages.roomRequired", "messages"),
        Constant.App.ToastTime.LongCloseTime
      );
    }
  }

  exploreRoomModel = () => {
    const { exploreCategory, roomType, rooms, selectedRoom } = this.state;
    const { changePopupState } = this.props;

    return (
      <Dialog
        disableAutoHideOnSubmit={true}
        disableBackdropClose={true}
        hideCloseButton={true}
        onCancel={() => this.cancelClick()}
        onSubmit={() => this.handleOnSubmit()}
        cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall") }}
        ok={{ translationKey: ct("rta-trmc.dashboard.otherRoom.join"), hidden: !rooms.length }}
        titleKey={ct("rta-trmc.dialogs.chooseRoomCat")}
        rtaClassName={"choose-room-category"}
        testId={"choose-room-category"}
      >
        <label htmlFor="Category">{ct("rta-trmc.dashboard.myRoom.category")}: </label>
        <select
          value={exploreCategory}
          name="exploreCategory"
          onChange={this.changeField}
          className="form-control roomCategory"
        >
          <option value="">{ct("rta-trmc.dashboard.myRoom.selectCategory")}</option>
          <option value="Uncategorized">{ct("rta-trmc.dialogs.uncategorized")}</option>
          <option value="Music">{ct("rta-trmc.dialogs.music")}</option>
          <option value="Vocal">{ct("rta-trmc.dialogs.vocal")}</option>
          <option value="Training">{ct("rta-trmc.dialogs.training")}</option>
          <option value="Singing">{ct("rta-trmc.dialogs.singing")}</option>
        </select>
        <br />
        <label htmlFor="roomType">{ct("rta-trmc.dialogs.roomType")}: </label>
        <div className="roomType">
          <input
            type="radio"
            id="private"
            name="roomType"
            value={"true"}
            checked={roomType === "true"}
            onChange={this.changeField}
          />
          <label htmlFor="private">{ct("rta-trmc.dashboard.myRoom.private")}</label>
          <br />
          <input
            type="radio"
            id="public"
            name="roomType"
            value={"false"}
            checked={roomType === "false"}
            onChange={this.changeField}
          />
          <label htmlFor="public">{ct("rta-trmc.dashboard.myRoom.public")}</label>
          <br />
          <input
            type="radio"
            id="both"
            name="roomType"
            value={"both"}
            checked={roomType === "both"}
            onChange={this.changeField}
          />
          <label htmlFor="both">{ct("rta-trmc.dialogs.both")}</label>
        </div>
        {rooms.length > 0 && (
          <div className="RoomsAvailable">
            <label htmlFor="Rooms">{ct("rta-trmc.dialogs.rooms")}: </label>
            <select
              value={selectedRoom}
              name="selectedRoom"
              onChange={this.changeField}
              className="form-control roomCategory"
            >
              {this.getRooms()}
            </select>
            <br />
          </div>
        )}
      </Dialog>
    );
  };

  onChange = (date) =>
    this.setState({
      claim: {
        ...this.state.claim,
        endDate: date,
      },
    });

  changePaymentField = ({ target: { name, value } }) =>
    this.setState({
      payment: {
        ...this.state.payment,
        [name]: value,
      },
    });

  checkRoomCurrentStatus = () => {
    const { dispatch, userLoginData } = this.props;
    const { isRoomStarted } = userLoginData;

    if (isRoomStarted) {
      this.props.changePopupState("d");
      _startConference(7);
    } else {
      getRoomDetail(lastSeg)
        .then((roomDetail) => {
          if (roomDetail?.data?.isPaid) {
            this.setState({ stopRoomPaymentInterval: true });
          }
          if (roomDetail.status == 1) {
            if (roomDetail.data.isRoomStarted) {
              dispatch(setWaitingScreen(false));
              this.props.changePopupState("e");
              _startConference(8);
            } else {
              dispatch(setWaitingScreen(true, 1));
              if (!userLoginData?.isAdmin && !userLoginData.isRoomStarted) {
                dispatch(setWaitingScreenStatus(true));
              }
            }
          } else {
            dispatch(setWaitingScreen(true, 2));
            if (!userLoginData?.isAdmin && !userLoginData.isRoomStarted) {
              dispatch(setWaitingScreenStatus(true));
            }
          }
        })
        .catch((error) => {
          dispatch(setWaitingScreen(true, 3));
          if (!userLoginData?.isAdmin && !userLoginData.isRoomStarted) {
            dispatch(setWaitingScreenStatus(true));
          }
        });
    }
  };

  handlePasswordForm = () => {
    const {
      payment: { card_number, expiry, cvc, password },
      claim: { userName, email },
    } = this.state;

    const config = {
      headers: {
        "content-type": "application/json",
      },
    };

    this.setState({
      isLoading: true,
    });
    let username = userName || this.props?.userLoginData?.user?.username

    axios
      .post(
        `${socket_endpoint + (getBaseConfig("apiVersion") || apiVersion)
        }/join_user_in_Room`,
        {
          userName: username,
          email,
          groupName: lastSeg,
          password,
        },
        config
      )
      .then(async (response) => {
        if (response.data.status) {
          sessionStorage.setItem("isPaid", true);
          this.props.changePopupState("f");

          const {
            dispatch,
            t,
            userLoginData,
            getLocalParticipant,
            authOrganization,
          } = this.props;
          const { email, userName, isAdmin, isRoomStarted, isRoomClaimed } =
            userLoginData;

          let ipAddress = CURRENT_ROOM_NAME;
          if (ipAddress) {
            ipAddress = ipAddress.toLowerCase().replace(/%20/g, "").trim();
          }

          if (ipAddress && userLoginData) {
            let obj = {
              isAdmin: isAdmin,
              name: userName,
              email: email,
              roomName: ipAddress,
              socketId: localStorage.getItem("socketId"),
              organization_id: authOrganization?._id,
              organization: authOrganization?.name,
              // jitsiId: getLocalParticipant.id
            };
            //socketEmit("user_added", obj);
          }
          this.checkRoomCurrentStatus();

          // dispatch(connect());
          //--- ADD ROOM STARTED

          // if (isRoomStarted) {
          //   _startConference();
          // } else {
          //   dispatch(setWaitingScreen(true));
          // }
        } else {
          // Toast(messages.contactAdmin);
          let msg = await dynamicMessageLocale(response.data.message);
          Toast(msg, Constant.App.ToastTime.LongCloseTime);
        }
      })
      .catch(async (error) => {
        let msg = await dynamicMessageLocale(error.response.data.message);
        Toast(
          msg,
          Constant.App.ToastTime.LongCloseTime
        );
      })
      .finally(() => {
        //alert("finally");
        this.setState({
          isLoading: false,
        });
      });
  };

  paidRoomStatus = () => {
    getRoomDetail(lastSeg)
      .then((roomDetail) => {
        if (roomDetail.status == 1) {
          if (roomDetail?.data?.isPaid) {
            this.setState({ stopRoomPaymentInterval: true });
            if (roomDetail.data.isRoomStarted) {
              if (roomDetail.data?.isPasswordProtected) {
                if (this.props.explorePop != "payment-pop") {
                  this.props.changePopupState('');
                }
                // get room started status
                dispatch(setUserMakeRoomPayment(true))
                // let _This = this;
                // setTimeout(function () {
                //   _This.props.changePopupState('payment-pop');
                // }, 2000)
              } else {
                dispatch(setWaitingScreen(false));
                this.props.changePopupState("g");
                _startConference(8);
              }
            } else {
              if (roomDetail.data?.isPasswordProtected) {

                if (this.props.explorePop != "payment-pop") {
                  this.props.changePopupState('');
                }
                dispatch(setUserMakeRoomPayment(true))
                // get room status
                // let _this = this;
                // setTimeout(function () {
                //   _this.props.changePopupState('payment-pop');
                // }, 2000)
              } else {
                this.props.changePopupState("");
                dispatch(setWaitingScreen(true, 4));
              }
            }
          }
        }
      })
      .catch((error) => {
        // dispatch(setWaitingScreen(true));
      });
  };

  makePayment = () => {
    // if(this.props.userLoginData.user?.is_invited == true){
    //   return null;
    // }
    let {
      userLoginData: {
        room: { id },
      },
    } = this.props;

    this.setState({
      isLoading: true,
    });

    let _thisV = this;

    setTimeout(function () {
      _thisV.setState({
        isLoading: false,
      });
    }, 60000);

    makeRoomPayment({
      room_id: id || this.props.userLoginData.room._id,
    }).then(async (res) => {
      this.setState({
        isLoading: false,
      });
      if (res.status == 0) {
        if (res.error == 403) {
          toast(ct("rta-trmc.dialogs.loginRequired"), Constant.App.ToastTime.LongCloseTime);
        } else {
          if (res?.message) {
            let msg = await dynamicMessageLocale(res.message)
            toast(msg, Constant.App.ToastTime.LongCloseTime);
          } else if (res.data != "" && typeof res.data == "string") {
            let msg = await dynamicMessageLocale(res.data);
            toast(msg, Constant.App.ToastTime.LongCloseTime);
          } else {
            toast(ct("rta-trmc.dashboard.subscription.failed"), Constant.App.ToastTime.LongCloseTime);
          }
        }
      } else {
        let { checkout_session, payment_url, session_id } = res.data;

        this.setState({
          paymentDetail: {
            url: payment_url,
            message: ct("stripeMessage.yourPaymentProgress", "stripeMessage"),
          },
          isMakingPayment: true,
          isLoading: true,
        });

        // var payWin = window.open(payment_url, 'newwin', 'height=800px,width=600px');
        var payWin = window.open(payment_url);

        let timer = setInterval(() => {
          this.paidRoomStatus();
          if (this.state.stopRoomPaymentInterval == true) {
            clearInterval(timer);
          }
        }, 10000);

        this.props.stripeSession({
          checkout_session,
          payment_url,
          session_id,
          payWin,
        });
      }
    });
  };

  PaymentPop = () => {
    const {
      claim: { userName },
      isLoading,
      payment: { card_number, expiry, cvc, password },
    } = this.state;
    // const {user: {room: {room_amount}, isPasswordProtected, isOpenRoom } } = this.props;
    const { userLoginData, isUserLogin, isModerator } = this.props;

    // check if current user is came after changing of music mode
    let hasMusicRoom = sessionStorage.getItem("claimedUserD");
    if (hasMusicRoom) {
      try {
        let musicUserDetail = JSON.parse(hasMusicRoom);
        if (
          musicUserDetail.roomName &&
          musicUserDetail.roomLocation &&
          musicUserDetail.time
        ) {
          if (
            calculateTimeDiff(musicUserDetail.time, messages.musicModeTimeLimit)
          ) {
            if (
              CURRENT_ROOM_LOCATION ==
              musicUserDetail.roomLocation
            ) {
              return null;
            }
          }
        }
      } catch (e) { }
    }

    if (isUserLogin) {
      if (userLoginData.isAdmin || isModerator) {
        return null;
      }
    }

    let showPayment = false;
    let showPassword = false;
    if (userLoginData.room.paid) {
      if (!userLoginData.isPaid) {
        showPayment = true;
      }
    }

    if (showPayment) {
      showPassword = false;
    } else if (userLoginData.isPasswordProtected) {
      showPassword = true;
    }

    let canShow = canUserJoinMeeting();
    let canShowPrejoin = getStore('features/prejoin')?.showPrejoin;
    if (!canShowPrejoin && !canShow) {
      let current_room_jamming_capability = getLJsonStorage("auth", "current_room_jamming_capability") || {}
      if (Object.keys(current_room_jamming_capability).length && current_room_jamming_capability?.status != 1) {
        canShow = true;
      }
    }

    if (!canShow) {
      if (userLoginData.user?.id && userLoginData.user?.is_invited == true) {
        //return null;
      } else {
        return null;
      }
    }

    if (this.props.isWaiting) {
      return null;
    }

    return <Dialog
      disableAutoHideOnSubmit={true}
      disableBackdropClose={true}
      hideCloseButton={true}
      onCancel={() => {
        if (isSocialMobileApp()) {
          window.parent.location.href = getBaseConfig("appReferrerUrl");
        } else {
          // social url change code
          let socialAllowed = getBaseConfig("socialAllowed");
          if (socialAllowed == true) {
            window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/OuIVuX07";
          } else {
            window.location.href = "/"
          }
        }
      }}
      onSubmit={() => {
        showPayment ? this.makePayment() : this.handlePasswordForm();
      }}
      cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall") }}
      ok={{ translationKey: showPayment ? ct("Translate.buttonTitle.clickToPay") : ct("Translate.buttonTitle.submit") }}
      titleKey={showPayment
        ? ct("Translate.messages.makePayment")
        : ct("Translate.messages.enterDetail")}
      rtaClassName="access-this-room"
      testId={"acessThisromePopup"}
    >
      <>
        <h2>{ct("rta-trmc.dialogs.loginRequired")} {lastSeg}</h2>
        {showPayment ? (
          <>
            <h3 style={{ color: "#333" }}>
              {ct("rta-trmc.dialogs.entranceFeeIs")}{userLoginData?.paidDetail?.amount}
            </h3>
            {this.state.paymentDetail.message && (
              <h4 style={{ color: "#333" }}>
                {this.state.paymentDetail.message}
              </h4>
            )}
          </>
        ) : (
          <>
            <label htmlFor="username">{ct("rta-trmc.dialogs.userName")}: </label>
            <br />
            <input
              id="username"
              name="username"
              type="text"
              value={userName || this.props?.userLoginData?.user?.username}
              className="form-control"
              readOnly
            />
            {userLoginData?.isPasswordProtected && (
              <>
                <label htmlFor="room-password">{ct("rta-trmc.dialogs.RoomPassword")}: </label>
                <br />
                <input
                  id="room-password"
                  name="password"
                  type="password"
                  value={password}
                  onChange={this.changePaymentField}
                  className="form-control"
                />
                <br />
              </>
            )}
          </>
        )}
      </>
    </Dialog>
  };

  currentDialog = () => {
    const {
      explorePop,
      changePopupState,
      user,
      openLogin,
      userLoginData,
      deviceContainerStatus,
      enableWebjamModal,
      bufferChangeUser,
      isBufferHostReady,
      showConnectPopup,
      _iAmRecorder,
      usersData,
      textMessage,
      showLoader,
      _isLiveStreamRunning,
      _isRecordingRunning,
      showDevicePreConnection,
      deviceList,
      conferenceJoined
    } = this.props;

    let showWebjam = false;
    if (
      (enableWebjamModal == true && bufferChangeUser == true) ||
      (isBufferHostReady == true && enableWebjamModal == true) ||
      showConnectPopup == false ||
      showConnectPopup == "bufferParticipant" ||
      localStorage.getItem("askAgain") ||
      localStorage.getItem("connectPop") == "true" ||
      _isRecordingRunning ||
      _isLiveStreamRunning
    ) {
      if (explorePop == "webjam") {
        console.log("showWebjam 1 =>", showWebjam);
      }
      showWebjam = false;
    } else if (localStorage.getItem("connectPop") == true) {
      if (explorePop == "webjam") {
        console.log("showWebjam 2 =>", showWebjam);
      }
      showWebjam = false;
    } else if (usersData != null) {
      if (explorePop == "webjam") {
        console.log("showWebjam 3 =>", showWebjam);
      }
      showWebjam = false;
    } else if (
      textMessage?.loaderAdditionalDetail ==
      Translate.messages.deviceConnecting &&
      showLoader
    ) {
      if (explorePop == "webjam") {
        console.log("showWebjam 4 =>", showWebjam);
      }
      showWebjam = false;
    } else if (enableWebjamModal == true && localStorage.getItem("askAgain") != true && deviceList.length) {
      if (explorePop == "webjam") {
        console.log("showWebjam 5 =>", showWebjam);
      }
      showWebjam = true;
    }

    // let current_room_jamming_capability = getLJsonStorage("auth", "current_room_jamming_capability") || {}
    // if (Object.keys(current_room_jamming_capability).length && current_room_jamming_capability.status && current_room_jamming_capability.status != 1) {
    //   showWebjam = false;
    // }

    if (
      window.location.hash.indexOf("config.iAmRecorder") != -1 ||
      window.location.hash.indexOf("AUDIO_GHOST") != -1 ||
      _iAmRecorder
    ) {
      return null;
    } else {
      if (explorePop === "create-room") {
        return this.createRoomModel();
      } else if (explorePop === "explore-room") {
        return this.exploreRoomModel();
      }
      // else if (explorePop === 'claim-room') { return this.claimRoomModel() }
      else if (explorePop === "settings" || explorePop === "claim-room") {
        return (
          <ClaimRoomComponent
            changePopupState={changePopupState}
            userEmail={user.email}
            userLoginData={userLoginData}
            stripeSession={this.props.stripeSession}
            roomType={
              explorePop == "claim-room" ? "create-room" : "update-room"
            }
          />
        );
      } // we will manage in one component not working yet
      else if (explorePop === "payment-pop") {
        return this.PaymentPop();
      } else if (explorePop === "add-participants") {
        return <AddParticipants changePopupState={changePopupState} />;
      } else if (explorePop === "upload") {
        return <Upload changePopupState={changePopupState} />;
      } else if (explorePop === "room-created") {
        return (
          <CreatedRoom
            openLogin={openLogin}
            isLogged={!!user.isLogged}
            closeDialog={changePopupState}
          />
        );
      } else if (explorePop === "embbeded-site") {
        return <Embbeded closeDialog={changePopupState} />;
      } else if ((explorePop === "webjam" || showWebjam) && !showLoader && conferenceJoined) {
        return <DeviceList explorePop={explorePop} changePopupState={changePopupState} />;
      } else if ((explorePop === "webjam-mixer" || deviceContainerStatus == "openmixer") && !showDevicePreConnection) {
        return <WebjamMixer changePopupState={changePopupState} />;
      } else if (explorePop === "create-payment-account") {
        return (
          <PaymentAccountModal
            changePopupState={changePopupState}
            stripeSession={this.props.stripeSession}
          />
        );
      } else return null;
    }
  };

  render() {
    return (
      <AtlasKitThemeProvider mode="dark">
        <ModalTransition key={this.props.deviceContainerStatus} >{this.currentDialog()}</ModalTransition>
      </AtlasKitThemeProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    isUserLogin: state[FEATURE_CUSTOM_REDUX].isUserLogin,
    isWaiting: state[FEATURE_CUSTOM_REDUX].isWaiting,
    userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
    usersData: state[FEATURE_CUSTOM_REDUX].usersData,
    isStripeConnect: state[FEATURE_CUSTOM_REDUX_V2].isStripeConnect,
    connectVerified: state[FEATURE_CUSTOM_REDUX_V2].isStripeConnectVerified,
    getLocalParticipant: getLocalParticipant(state),
    isModerator: isLocalParticipantModerator(state),
    authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization,
    deviceContainerStatus: state[FEATURE_CUSTOM_REDUX_V2].deviceContainerStatus,
    enableWebjamModal: state[FEATURE_CUSTOM_REDUX_V2].enableWebjamModal,
    bufferChangeUser: state[FEATURE_CUSTOM_REDUX_V2].bufferChangeUser,
    showConnectPopup: state[FEATURE_CUSTOM_REDUX_V2].showConnectPopup,
    _iAmRecorder: state["features/base/config"].iAmRecorder,
    showLoader: state["trmc/customLoader/modal"].showLoader,
    textMessage: state["trmc/customLoader/modal"].textMessage,
    _isLiveStreamRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.STREAM)),
    _isRecordingRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.FILE)),
    showDevicePreConnection: state[FEATURE_CUSTOM_REDUX_V3].showDevicePreConnection,
    isSubscriptionActive: checkSubscription(),
    deviceList: state[FEATURE_CUSTOM_REDUX].deviceList,
    conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined
  };
}

export default reactReduxConnect(mapStateToProps)(Explore);
